import { SETTINGS } from './index';
import { Action } from '../action';

export class SettingsInitAction implements Action {
	readonly type = SETTINGS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SettingsDestroyAction implements Action {
	readonly type = SETTINGS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SettingsClickAction implements Action {
	readonly type = SETTINGS.CLICK;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
